/* eslint-disable-next-line no-redeclare */
/* global window */
/* eslint-disable no-alert */
export default window.confirm;
